import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
export default function Shape(props) {
  const $ = _c(11);
  const t0 = shapeProps[props.type];
  let otherProps;
  let shapeColor;
  if ($[0] !== t0) {
    ({
      color: shapeColor,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = shapeColor;
  } else {
    otherProps = $[1];
    shapeColor = $[2];
  }
  const t1 = props.color ?? shapeColor;
  let t2;
  if ($[3] !== props.className || $[4] !== t1) {
    t2 = cx(props.className, t1, "pointer-events-none");
    $[3] = props.className;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = shapes[props.type];
  let t4;
  if ($[6] !== otherProps || $[7] !== props.style || $[8] !== t2 || $[9] !== t3) {
    t4 = <svg {...otherProps} className={t2} style={props.style}>{t3}</svg>;
    $[6] = otherProps;
    $[7] = props.style;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function HalfCircle() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M112 0C50.1441 0 0 50.1441 0 112C0 173.856 50.1441 224 112 224V0Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function PacMan() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M92.94 0L74.35 18.59L55.76 0L0 55.76C0 96.82 33.29 130.11 74.35 130.11C115.41 130.11 148.7 96.82 148.7 55.76L92.94 0Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function HalfDonut() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M224.561 0C224.561 61.8559 174.417 112 112.561 112C50.7046 112 0.560547 61.8559 0.560547 0H56.5605C56.5605 30.9279 81.6328 56 112.561 56C143.488 56 168.561 30.9279 168.561 0H224.561Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function Dot() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M66.9905 132.86C103.679 132.86 133.421 103.118 133.421 66.43C133.421 29.7417 103.679 0 66.9905 0C30.3023 0 0.560547 29.7417 0.560547 66.43C0.560547 103.118 30.3023 132.86 66.9905 132.86Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
const shapeProps = {
  halfCircle: {
    color: 'fill-tertiary',
    viewBox: '0 0 224 224',
    width: 112,
    height: 224
  },
  pacMan: {
    color: 'fill-yellow-500',
    viewBox: '0 0 149 131',
    width: 149,
    height: 131
  },
  halfDonut: {
    color: 'fill-salmon-500',
    viewBox: '0 0 225 112',
    width: 225,
    height: 112
  },
  dot: {
    color: 'fill-secondary',
    viewBox: '0 0 134 133',
    width: 132.86,
    height: 132.86
  }
} as const;
const shapes = {
  halfCircle: <HalfCircle />,
  pacMan: <PacMan />,
  halfDonut: <HalfDonut />,
  dot: <Dot />
};
export type ShapeType = keyof typeof shapes;